import styles from './Author.module.scss'
import { AuthorProps } from './types'
import { Img } from '@boltenergy-be/design-system'

const Author = ({ name, date, imagePublicId }: AuthorProps) => {
  return (
    <div className={styles['author-container']}>
      {imagePublicId && <Img publicId={imagePublicId} width={48} height={48} alt={name} className={styles.avatar} />}
      <div>
        <time className={styles.date}>{date}</time>
        <div className={styles.author}>{name}</div>
      </div>
    </div>
  )
}

export default Author
